"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("./Headings/styles");
var styles_2 = require("./Paragraphs/styles");
var Typography = {
    H1: styles_1.H1,
    H2: styles_1.H2,
    H3: styles_1.H3,
    H4: styles_1.H4,
    H5: styles_1.H5,
    H6: styles_1.H6,
    Body: styles_2.Body,
    Caption: styles_2.Caption,
    Footer: styles_2.Footer,
};
exports.default = Typography;
